<template>
  <div>
    <div class="page-container">
      <md-app md-waterfall md-mode="fixed" style="min-height: 100vh;">
        <md-app-toolbar class="md-primary">
          <div class="d-flex order-lg-2">
            <img
              src="../assets/images/logo2.png"
              loading="lazy"
              style="height:100px;"
            />
          </div>
          <div style="margin-left: auto !important;">
            <h3 class="title">UFA Easy888</h3>
            <div
              style="justify-content: center; display: flex; margin-top: 8px;"
            >
              <span style="font-size: 16px; color: yellow;">{{ code }}</span>
            </div>
          </div>
          <div class="d-flex order-lg-2 ml-auto">
            <div class="dropdown">
              <a
                href="#"
                class="nav-link pr-0 leading-none"
                data-toggle="dropdown"
              >
                <span
                  class="avatar"
                  id="avatar"
                  :style="{ 'background-image': `url(${pictureUrl})` }"
                ></span>
              </a>
            </div>
          </div>
        </md-app-toolbar>

        <md-app-content id="withdraw">
          <div style="marginLeft: 32px; marginTop: 16px;">
            <h1 class="md-title">ร่วมสนุกทายผลฟุตบอล</h1>
          </div>

          <div
            style="width: 90%; height: 1px; background-color: #212121; margin-top: 14px; margin-left:16px"
          />
          <div style="margin-top: 16px; margin-left: 16px;">
              <div align="center"><span style="font-size: 15px; color: yellow;">*************************</span></div><br>
              <span style="font-size: 13px; color: #FFFFFF;"> กติการ่วมสนุกเพียงท่านมียอดแจ้งฝากวันนี้เพียง 300 ลุ้นทายผลฟุตบอลวันนี้ ถ้าท่านทายถูกครบทุกคู่รับไปเลยเครดิต 2000 ถ้วน!!!</span><br>
              <div align="center"><span style="font-size: 15px; color: yellow;">*************************</span></div>
            </div>
          <div style="margin-top: 16px; margin-left: 16px; margin-bottom: 64px;">
            <table id="customers">
            <tbody>
                <tr v-for="(item,index) in football"  :key="index">
                  <template v-if="item.selected  && item.selected == 1">
                    <td align="right" @click="changeRowColor(index,1)" style="background-color: darkcyan">{{item.team1}}</td>
                  </template>
                  <template v-else>
                    <td align="right" @click="changeRowColor(index,1)" >{{item.team1}}</td>
                  </template>
                  
                  <template v-if="item.selected  && item.selected == 2">
                    <td align="center" @click="changeRowColor(index,2)" style="background-color: darkcyan">&nbsp;เสมอ</td>
                  </template>
                  <template v-else>
                    <td align="center" @click="changeRowColor(index,2)">&nbsp;เสมอ</td>
                  </template>
                  <template v-if="item.selected  && item.selected == 3">
                    <td align="left" @click="changeRowColor(index,3)" style="background-color: darkcyan">&nbsp;{{item.team2}}</td>
                  </template>
                  <template v-else>
                    <td align="left" @click="changeRowColor(index,3)">&nbsp;{{item.team2}}</td>
                  </template>
                </tr>
            </tbody>
            </table>
            <div style="margin-top: 32px; display: flex; margin-bottom: 64px;" v-if="!disabled && football.length > 0">
              <button
                style="display: flex; background-color: yellow; height: 50px; width: 100%; margin-left: 20px; margin-right: 20px; align-items: center; justify-content: center;"
                @click="confirm()"
                :disabled="disabled"
              >
                <span style="color: #000; font-size: 16px; font-weight: bold;"
                  >ร่วมสนุก</span
                >
              </button>
            </div>
          </div>
        </md-app-content>
      </md-app>
    </div>
    <BottomMenu></BottomMenu>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import moment from "moment-timezone";
import router from "./../router";
import liffService from "@/services/liff";
const axios = require("axios").default;
export default {
  name: "Withdraw",
  components: {
    BottomMenu: require("./BottomMenu").default
  },
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      userId:"",
      menuVisible: false,
      pictureUrl: "",
      history: [],
      credit: "loading..",
      creditTotal: "loading..",
      name: "",
      bank: "",
      accountno: "",
      money: "",
      error: 0,
      bankImage: "",
      code: "",
      items:[],
      selected:[],
    };
  },
  computed: {
    football() {
        return this.$store.getters['football/football'];
    },
    disabled() {
        return this.$store.getters['football/disabled'];
    }
  },
  methods: {
    changeRowColor(index,selected){
        if(!this.disabled)
        this.$store.dispatch('football/setSelected',{index,selected});
    },
    async confirm() {
      let check = false;
      for(const x in this.football){
          if(this.football[x].selected === 0 ){
              check = true;
              break;
          }
      }
      if(check){
          alert('โปรดระบุให้ครบทุกคู่ค่ะ');
          return;
      }else{
          this.$store.dispatch('football/saveFootball',this.userId).then(async ()=>{
            await window.liff.sendMessages([
            {
                "type": "text",
                "text": "ขอบคุณที่ร่วมสนุกทายผลฟุตบอลกับทางเรา",
            }]);
            window.liff.closeWindow();
          });
      }
    },
    addCommasInNubmer: value => {
      let num, oneDigit, str;
      if (typeof value === "number") {
        num = value.toFixed(2);
      } else {
        num = value;
      }

      str = num.toString().split(".");
      if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      }
      if (str[1]) {
        oneDigit = str[1].split("");
        if (str[1] === "00") {
          str = str[0];
        } else if (oneDigit[1] === "0") {
          str[1] = oneDigit[0];
          str = str.join(".");
        } else {
          str = str.join(".");
        }
      } else {
        str = str[0];
      }
      return str;
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        this.$store.dispatch('football/getData',this.userId);
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
            router.replace("/register");
        } 
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.md-app {
  height: 500px;
  border: 1px solid rgba(#000, 0.12);
}
.md-toolbar.md-theme-default.md-primary {
  background-color: #000;
}
.md-content.md-theme-default {
  background-color: #000;
}
// Demo purposes only
.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}
.md-card.md-theme-default {
  background-color: #000;
  background-color: var(--md-theme-default-background, #000);
}
</style>
<style>
.md-table-content {
  background-color: #000 !important;
  background-color: var(--md-theme-default-background, #000) !important;
}
.md-app-scroller {
  background-color: #000 !important;
}
.md-table .md-table-head-text,
.md-table .md-table-cell .md-table-cell-container {
  padding-right: 5;
  padding-left: 0;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  font-size: 13px;
  border-collapse: collapse;
  width: 100%;
}

#customers td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
}
</style>
